import {setContext} from '@apollo/client/link/context';
import {ApolloClient, ApolloLink, ApolloProvider, HttpLink} from '@jimmyn/apollo-client';
import {cache} from 'api/cache';
import {Auth} from 'aws-amplify';
import {AuthOptions, createAuthLink} from 'aws-appsync-auth-link';
import {AUTH_TYPE} from 'aws-appsync-auth-link/lib';
import {createSubscriptionHandshakeLink} from 'aws-appsync-subscription-link';
import {ComplexObjectLink} from 'aws-appsync/lib/link';
import {GlobalLoadingIndicator, networkStatusLink} from 'components/GlobalLoadingIndicator';
import {MainLayout} from 'layout';
import {cleanTypenameLink} from 'lib/cleanTypenameLink';
import React from 'react';
import {BrowserRouter as Router, Route} from 'react-router-dom';
import {config} from 'stage.config';
import {QueryParamProvider} from 'use-query-params';
import {Helmet} from 'react-helmet';

const httpLink = new HttpLink({uri: config.graphqlEndpoint});

const liveModeLink = setContext((request, previousContext) => ({
  headers: {
    'm-test-mode': localStorage.getItem('m-test-mode') ?? 'false'
  }
}));

const params = {
  url: config.graphqlEndpoint,
  region: config.region,
  auth: {
    type: AUTH_TYPE.AMAZON_COGNITO_USER_POOLS,
    jwtToken: async () => (await Auth.currentSession()).getIdToken().getJwtToken()
  } as AuthOptions
};

const authLink = createAuthLink(params);

const subscriptionLink = createSubscriptionHandshakeLink(params, httpLink);
const complexObjectLink = new ComplexObjectLink(() => Auth.currentUserCredentials());

const link = ApolloLink.from([
  networkStatusLink,
  liveModeLink,
  complexObjectLink,
  cleanTypenameLink,
  authLink,
  subscriptionLink
]);

const client = new ApolloClient({
  link,
  cache
});

const App: React.FC<{}> = () => {
  return (
    <ApolloProvider client={client}>
      <GlobalLoadingIndicator />
      <Helmet titleTemplate="%s | MONEI Admin" defaultTitle="MONEI Admin" />
      <Router>
        <QueryParamProvider ReactRouterRoute={Route}>
          <MainLayout />
        </QueryParamProvider>
      </Router>
    </ApolloProvider>
  );
};

export default App;
